<atx-modal-header
  (dismiss)="close()"
  showCloseBtn="true"
  class="border-bottom-0"
>
</atx-modal-header>

<atx-modal-body class="pt-0">
  <div class="d-flex">
    @if (imageSrc) {
    <img [src]="imageSrc" alt="thumbnail" class="mr-2 align-self-start" />
    }
    <div class="d-flex flex-column">
      @if (title) {
      <span class="mb-3 font-weight-bold">
        {{ title }}
      </span>
      } @if (message) {
      <span class="text-muted">
        {{ message }}
      </span>
      }
      <button
        class="btn btn-primary my-4 w-50"
        data-e2e="cool-close-btn"
        i18n="
          UserMenu|Enable feature modal button
          text@@enablingFeatureModalButtonText"
        (click)="close()"
      >
        Cool, got it
      </button>
    </div>
  </div>
</atx-modal-body>
